import Alpine from "alpinejs";
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
Alpine.data("contentSlider", () => ({
    splideInstances: {},


    configuration: {
        directions: 'ltr',
        type: 'loop',
        speed: 800,

        slidesPerPage: {
            desktop: 2,
            tablet: 1,
            mobile: 1
        },

        slidesPerMove: {
            desktop: 1,
            tablet: 1,
            mobile: 1
        },

        gap: {
            desktop: '16',
            tablet: '16',
            mobile: '16'
        },

        autoplay: false,
        pauseOnHover: false,
        arrows: true,
        arrowsStyle: {
            circleColor: '#CCCCCC',
            arrowColor: '#000000'
        },
        pagination: true,
        paginationStyle: {
            color: '#CCCCCC',
            activeColor: '#ffffff'
        },

        progressIndicator: false,
        progressIndicatorStyle: {
            color: '#CCCCCC',
            activeColor: '#ADFF2F',
            height: 2
        },

        gridEnabled: false,
        wheel: false,
        autoScroll: false,
        autoScrollSpeed: 1,

        sliderHeight: {
            desktop: '',
            tablet: '',
            mobile: ''
        },

    },

    init(sliderId, configuration) {

        if (sliderId) {
            const initialConfig = {
                configuration: configuration
            }

            this.reinitSlider(sliderId, initialConfig);
        }

        // Attach a message listener to reinitialize sliders dynamically
        window.addEventListener('message', (event) => {
            if (event.data.type === 'change-contentSliderSettings') {
                let json = JSON.parse(event.data.data);
                const incomingSliderId = json.id;

                // Reinitialize the specific slider
                if (incomingSliderId) {
                    this.reinitSlider(incomingSliderId.replace("slider", ""), json);
                }
            }
        });
    },

    reinitSlider(sliderId, json) {
        const sliderSelector = '#slider' + sliderId;

        if (this.splideInstances[sliderId]) {
            this.splideInstances[sliderId].splide.destroy();
        }

        if (!this.splideInstances[sliderId]) {
            this.splideInstances[sliderId] = {}; // Initialize the object if it doesn't exist
        }

        const type = json && json.configuration && json.configuration.type ? json.configuration.type : this.type;
        const progressIndicator = json && json.configuration && json.configuration.progressIndicator ? json.configuration.progressIndicator : false;
        const autoScrollEnabled = json && json.configuration && json.configuration.autoScroll ? json.configuration.autoScroll : false;

        const autoScrollSpeed = json && json.configuration && json.configuration.autoScrollSpeed ? json.configuration.autoScrollSpeed : 1;
        const slidersPerMove = json && json.configuration && json.configuration.slidesPerMove && json.configuration.slidesPerMove.desktop ? json.configuration.slidesPerMove.desktop : this.perMove;

        this.splideInstances[sliderId].splide = new Splide(sliderSelector, {
            lazyLoad: 'nearby',
            height: json && json.configuration && json.configuration.sliderHeight && json.configuration.sliderHeight.desktop ? json.configuration.sliderHeight.desktop + 'px' : this.height,
            ...(type !== 'fade' ?
                { perPage: json && json.configuration && json.configuration.slidesPerPage && json.configuration.slidesPerPage.desktop ? json.configuration.slidesPerPage.desktop : this.perPage } :
                {}),
            perMove:  slidersPerMove,
            gap: json && json.configuration && json.configuration.gap && json.configuration.gap.desktop ? json.configuration.gap.desktop + 'px' : this.gap,
            rewind: this.rewind,
            cover: this.cover,
            speed: json && json.configuration && json.configuration.speed ? json.configuration.speed : this.speed,
            direction: json && json.configuration && json.configuration.directions ? json.configuration.directions : 'ltr',
            autoplay: json && json.configuration && json.configuration.autoplay ? json.configuration.autoplay : false,
            pauseOnHover: json && json.configuration && json.configuration.pauseOnHover ? json.configuration.pauseOnHover : false,
            arrows: json && json.configuration ? json.configuration.arrows : true,
            pagination: json && json.configuration ? json.configuration.pagination : true,

            wheel: json && json.configuration ? json.configuration.wheel : false,
            waitForTransition: json && json.configuration ? json.configuration.wheel : false,

            type   : 'loop',
            drag   : 'free',

            breakpoints: {
                1024: {
                    height: json && json.configuration && json.configuration.sliderHeight && json.configuration.sliderHeight.tablet ? json.configuration.sliderHeight.tablet + 'px' : this.height,
                    perPage: json && json.configuration && json.configuration.slidesPerPage && json.configuration.slidesPerPage.tablet ? json.configuration.slidesPerPage.tablet : this.perPage,
                    perMove:  json && json.configuration && json.configuration.slidesPerMove && json.configuration.slidesPerMove.tablet ? json.configuration.slidesPerMove.tablet : this.perMove,
                    gap: json && json.configuration && json.configuration.gap && json.configuration.gap.tablet ? json.configuration.gap.tablet + 'px' : this.gap,
                },
                767: {
                    height: json && json.configuration && json.configuration.sliderHeight && json.configuration.sliderHeight.mobile ? json.configuration.sliderHeight.mobile + 'px' : this.height,
                    perPage: json && json.configuration && json.configuration.slidesPerPage && json.configuration.slidesPerPage.mobile ? json.configuration.slidesPerPage.mobile : this.perPage,
                    perMove:  json && json.configuration && json.configuration.slidesPerMove && json.configuration.slidesPerMove.mobile ? json.configuration.slidesPerMove.mobile : this.perMove,
                    gap: json && json.configuration && json.configuration.gap && json.configuration.gap.mobile ? json.configuration.gap.mobile + 'px' : this.gap,
                },
            },

            autoScroll: {
                speed: autoScrollSpeed,
            },
        });

        var splideInstance = this.splideInstances[sliderId].splide;
        var bar = document.querySelector('.my-slider-progress').querySelector('.my-slider-progress-bar');


        if (progressIndicator) {
            if (bar) {
                // Function to update the progress bar
                function updateProgressBar() {
                    var end = splideInstance.Components.Controller.getEnd() + 1;
                    var rate = Math.min((splideInstance.index + 1) / end, 1); // Ensure the rate is between 0 and 1
                    bar.style.width = (100 * rate) + '%'; // Update width as percentage
                    document.querySelector('.my-slider-progress').style.display = 'block';
                }

                splideInstance.on('mounted move active', updateProgressBar);
                setTimeout(() => {
                    // Use draggedElement instead of event.target
                    document.querySelector('.my-slider-progress').style.display = 'block';
                }, 0);
            }
        }else {
            document.querySelector('.my-slider-progress').style.display = 'none';
        }


        const extensions = {};
        if (autoScrollEnabled) extensions.AutoScroll = AutoScroll;

        this.splideInstances[sliderId].splide.mount(extensions);

        if (json) {
            const arrowsElements = splideInstance.root.querySelectorAll('.splide__arrow'); // Use querySelectorAll to select all arrows
            const dotsElements = document.querySelector(sliderSelector).querySelectorAll('.splide__pagination__page');
            //const dotsActiveElements = document.querySelector(sliderSelector).querySelectorAll('.splide__pagination__page');
            const progressBar = document.querySelector('#progress' + sliderId)
            arrowsElements.forEach(_element => {
                // Set the background color of the circle (arrow's container)
                if (json.configuration && json.configuration.arrowsStyle) {
                    _element.style.background = json.configuration.arrowsStyle.circleColor;
                } else {
                    console.error('json.configuration or json.configuration.arrowsStyle is undefined');
                }

                // Set the fill color of the SVG (the arrow itself)
                const svg = _element.querySelector('svg');
                if (svg) {
                    if (json.configuration && json.configuration.arrowsStyle) {
                        svg.style.fill = json.configuration.arrowsStyle.arrowColor;
                    }
                }
            });

            dotsElements.forEach(_element => {
                // Set the default background color for all dots
                _element.style.background = json.configuration.paginationStyle.color;

                // If the dot is active, you can apply a different background color or style
                if (_element.classList.contains('is-active')) {
                    _element.style.background = json.configuration.paginationStyle.activeColor; // Color for active dot
                }
            });

            splideInstance.on('move', () => {
                // Reset all dots
                dotsElements.forEach(_element => {
                    _element.style.background = json.configuration.paginationStyle.color;
                });

                // Apply styles to the new active dot
                const activeDot = document.querySelector('.splide__pagination__page.is-active');
                if (activeDot) {
                    activeDot.style.background = json.configuration.paginationStyle.activeColor;
                }
            });

            //document.querySelector(sliderSelector).querySelector('.splide__pagination__page.is-active').style.background = json.configuration.paginationStyle.activeColor;

            progressBar.style.background = json.configuration.progressIndicatorStyle.color;
            progressBar.style.height = json.configuration.progressIndicatorStyle.height + 'px';
            progressBar.querySelector('.my-slider-progress-bar').style.background = json.configuration.progressIndicatorStyle.activeColor;
            progressBar.querySelector('.my-slider-progress-bar').style.height = json.configuration.progressIndicatorStyle.height + 'px';
        }
    }
}));
